import clsx from 'clsx';

import {
  type DataTestId,
  type StylingProps,
  type WithChildren,
  _canReceiveDefaultTextFormat,
} from '@dynatrace/strato-components/core';
import { Flex } from '@dynatrace/strato-components/layouts';
import { Text } from '@dynatrace/strato-components/typography';

import * as styles from './SuggestionDetails.sty.js';
import { TextEllipsisAroundChildren } from '../../../core/components/TextEllipsisChildren.js';

/**
 * Accepted properties for FilterField suggestion details.
 * @public
 */
export type FilterFieldSuggestionDetailsProps = WithChildren &
  StylingProps &
  DataTestId;

/**
 * The `FilterField.SuggestionDetails` can be used to render additional
 * information for a suggestion.
 * @public
 */
export const SuggestionDetails = (props: FilterFieldSuggestionDetailsProps) => {
  const {
    children,
    className: consumerClassName,
    style: consumerStyle,
    'data-testid': dataTestId,
  } = props;
  const childIsText = _canReceiveDefaultTextFormat(children);

  return (
    <Flex
      className={clsx(styles.suggestionDetails, consumerClassName)}
      style={consumerStyle}
      data-testid={dataTestId}
      alignItems="center"
      paddingY={2}
    >
      {childIsText ? (
        <Text textStyle="small" className={styles.suggestionDetailsText}>
          <TextEllipsisAroundChildren>{children}</TextEllipsisAroundChildren>
        </Text>
      ) : (
        children
      )}
    </Flex>
  );
};

SuggestionDetails.displayValue = 'FilterField.SuggestionDetails';
